import type { StoreSpecial as V3StoreSpecial } from '@iheartjane/data-access';
import reduce from 'lodash-es/reduce';

/* eslint-disable-next-line no-restricted-imports */
import type { StoreSpecial } from '@jane/shared/models';
import type { StoreSpecial as ZodStoreSpecial } from '@jane/shared/types';

export const getSpecialsLabels = <
  T extends StoreSpecial | ZodStoreSpecial | V3StoreSpecial = StoreSpecial,
>(
  specials: T[]
) => {
  return reduce<T, Record<string, string>>(
    specials,
    (acc, special) => ({
      ...acc,
      [special.id.toString()]: special.title,
    }),
    {}
  );
};
